// extracted by mini-css-extract-plugin
export default {"embedWrapper":"EmbedPage_embedWrapper__OoOQh","statusText":"EmbedPage_statusText__nE3g2"};